import Vue from "vue";

Vue.component('fomo-notifications', require('./components/Global/FomoNotifications.vue').default)
Vue.component("loading", require("./components/Global/Loading.vue").default);
Vue.component("notification", require("./components/Global/Notification/Notification.vue").default);
Vue.component("sign-in-button", require("./components/Global/SignIn/ButtonSignIn.vue").default);
Vue.component("sign-in-modal", require("./components/Global/SignIn/ModalSignIn.vue").default);
Vue.component("subscribe-panel", require("./components/Global/SubscribePanel.vue").default);
Vue.component('navbar', require('./components/Global/Navbar/Navbar.vue').default)
Vue.component('nav-bar-mobile-panel', require('./components/Global/Navbar/NavBarMobilePanel.vue').default)
Vue.component("the-notice-bar", require("./components/TheNoticeBar.vue").default);
Vue.component("drybrush-footer", require("./components/Global/DrybrushFooter.vue").default);
Vue.component("footer-payment-methods", require("./components/Global/FooterPaymentMethods.vue").default);
Vue.component("artwork-slide-show", require("./components/Global/SlideShow/ArtworkSlideShow.vue").default);
Vue.component('favorite-link', require('./components/Global/FavoriteLink.vue').default)
Vue.component('cart-link', require('./components/Global/CartLink.vue').default)
Vue.component("the-artist-subscription-panel", require("./components/Modules/Artists/TheArtistSubscriptionPanel").default);
Vue.component("user-button", require("./components/Global/UserButton.vue").default);
